import { render, staticRenderFns } from "./ScenarioComboBox.vue?vue&type=template&id=4672c252&scoped=true&"
import script from "./ScenarioComboBox.vue?vue&type=script&lang=js&"
export * from "./ScenarioComboBox.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioComboBox.vue?vue&type=style&index=0&id=4672c252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672c252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {
  VCombobox,
})
